export function addCurrent(calledclassification) {
    return {
        type: 'ADD_CURRENT',
        calledclassification,
    }
}
